<template>
  <v-dialog v-model="dialog" :persistent="true" :max-width="650" :min-width="200">
    <v-card class="px-0">
      <v-card-title
          class="white--text headline my-0"
          :class="`headline primary`"
      >
        <span class="text-h6">{{$tc('title.atencao_comunicado_importante')}}</span>
      </v-card-title>
      <v-card-text class="pt-6 pb-0 py-0">
        <div v-html="mensagemModalAvisoLogin"></div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            dark
            @click="confirmaVisualizacaoMensagem">
          {{$tc('message.ok_entendi')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'MensagemAvisoLoginDialog',
  props: {
    tenantId: String,
  },
  data() {
    return {
      dialog: false,
      mensagemModalAvisoLogin: '',
    };
  },
  methods: {
    open(mensagem) {
      this.mensagemModalAvisoLogin = mensagem;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    confirmaVisualizacaoMensagem() {
      this.$emit('agree');
      this.close();
    },
  },
};
</script>
